import { Injectable, inject } from '@angular/core';

import { AccaBoostConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, concatMapTo, filter, first, map, noop, repeat, timer } from 'rxjs';

import { BetslipIntegrationService } from '../../betslip/integration/betslip-integration.service';
import { AccaBoostRefreshTrigger } from './acca-boost-token-provider.service';

@Injectable({ providedIn: 'root' })
export class AccaBoostRefreshTriggerService implements AccaBoostRefreshTrigger {
    private betslipIntegrationService = inject(BetslipIntegrationService);
    private config = inject(AccaBoostConfig);

    getTrigger$(): Observable<void> {
        const whenBetslipGetsEmpty$ = this.betslipIntegrationService.betslipPicksCount$().pipe(
            filter((pickCount) => pickCount === 0),
            first(),
            map(noop),
        );
        const pollingInterval$ = timer(this.config.pollingInterval);

        // emit after polling interval and only when betslip gets empty
        return pollingInterval$.pipe(concatMapTo(whenBetslipGetsEmpty$), repeat());
    }
}
